import { SLOTS } from './slots.js'

// Media library images. Image-heavy set, so grid is the default view. Edits happen
// via a drawer on the index page (there is no detail/edit route), so PRIMARY is not
// linked. The page itself keeps a bespoke ClickableImage grid to preserve the
// lightbox; this config drives the standard table view and any future reuse.
export default {
  key: 'media',
  label: 'Image',
  icon: 'media',
  columns: [
    { slot: SLOTS.PRIMARY, field: 'title', label: 'Title' },
    {
      slot: SLOTS.CONTEXT,
      label: 'Place',
      field: 'place.label',
      link: 'place.url'
    },
    { slot: SLOTS.METADATA, field: 'url', label: 'Image', renderer: 'media_thumb' },
    { slot: SLOTS.METADATA, field: 'all_tags', label: 'Tags', renderer: 'tags' }
  ],
  empty: { icon: 'media', message: 'No images found.' },
  defaultView: 'grid',
  grid: { show: [SLOTS.PRIMARY, SLOTS.CONTEXT, SLOTS.METADATA], columns: 6 }
}
